export const ReportsPage = () => {
  return (
    <div>Reports page</div>
  )
}
